import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const ToDoList = () => {
  const routes = all_routes;
  const [filter, setFilter] = useState('all');

  // Mock todo data
  const mockTodos = [
    {
      id: 1,
      task: "Complete Math homework - Chapter 5",
      category: "Homework",
      priority: "high",
      dueDate: "2024-12-25",
      completed: false,
      subject: "Mathematics"
    },
    {
      id: 2,
      task: "Study for Physics quiz",
      category: "Study",
      priority: "medium",
      dueDate: "2024-12-26",
      completed: false,
      subject: "Physics"
    },
    {
      id: 3,
      task: "Submit History essay",
      category: "Assignment",
      priority: "high",
      dueDate: "2024-12-24",
      completed: true,
      subject: "History"
    },
    {
      id: 4,
      task: "Prepare for Chemistry lab",
      category: "Lab",
      priority: "medium",
      dueDate: "2024-12-27",
      completed: false,
      subject: "Chemistry"
    },
    {
      id: 5,
      task: "Read English literature - Chapter 3",
      category: "Reading",
      priority: "low",
      dueDate: "2024-12-28",
      completed: false,
      subject: "English"
    }
  ];

  const filteredTodos = mockTodos.filter(todo => {
    if (filter === 'completed') return todo.completed;
    if (filter === 'pending') return !todo.completed;
    return true;
  });

  const getPriorityColor = (priority: string) => {
    switch(priority) {
      case 'high': return 'badge-soft-danger';
      case 'medium': return 'badge-soft-warning';
      case 'low': return 'badge-soft-success';
      default: return 'badge-soft-secondary';
    }
  };

  const getCategoryIcon = (category: string) => {
    switch(category) {
      case 'Homework': return 'ti-book';
      case 'Study': return 'ti-brain';
      case 'Assignment': return 'ti-file-text';
      case 'Lab': return 'ti-flask';
      case 'Reading': return 'ti-book-2';
      default: return 'ti-check';
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="d-md-flex d-block align-items-center justify-content-between border-bottom pb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">To-Do List</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.studentDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Student</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  To-Do List
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <div className="pe-1 mb-2">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">Refresh</Tooltip>}
              >
                <Link
                  to="#"
                  className="btn btn-outline-light bg-white btn-icon me-1"
                >
                  <i className="ti ti-refresh" />
                </Link>
              </OverlayTrigger>
            </div>
            <div className="pe-1 mb-2">
              <button 
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#addTodoModal"
              >
                <i className="ti ti-plus me-2"></i>Add Task
              </button>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="row mt-4">
          <div className="col-xl-3 col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-lg bg-primary-transparent me-3">
                    <i className="ti ti-list-check"></i>
                  </div>
                  <div>
                    <h4>{mockTodos.length}</h4>
                    <p className="text-muted mb-0">Total Tasks</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-lg bg-warning-transparent me-3">
                    <i className="ti ti-clock"></i>
                  </div>
                  <div>
                    <h4>{mockTodos.filter(t => !t.completed).length}</h4>
                    <p className="text-muted mb-0">Pending</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-lg bg-success-transparent me-3">
                    <i className="ti ti-check"></i>
                  </div>
                  <div>
                    <h4>{mockTodos.filter(t => t.completed).length}</h4>
                    <p className="text-muted mb-0">Completed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-lg bg-danger-transparent me-3">
                    <i className="ti ti-alert-triangle"></i>
                  </div>
                  <div>
                    <h4>{mockTodos.filter(t => !t.completed && t.priority === 'high').length}</h4>
                    <p className="text-muted mb-0">High Priority</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between">
                <h4 className="card-title">My Tasks</h4>
                <div className="d-flex gap-2">
                  <select 
                    className="form-select form-select-sm"
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                  >
                    <option value="all">All Tasks</option>
                    <option value="pending">Pending</option>
                    <option value="completed">Completed</option>
                  </select>
                </div>
              </div>

              {/* TODO Placeholders */}
              <div className="card-body border-bottom">
                <div className="alert alert-info">
                  <h6><i className="ti ti-info-circle me-2"></i>TODO: Connect to tasks API</h6>
                  <ul className="mb-0">
                    <li>Fetch personal tasks from database</li>
                    <li>Add/Edit/Delete task functionality</li>
                    <li>Mark tasks as complete/incomplete</li>
                    <li>Set reminders and notifications</li>
                    <li>Sync with homework assignments</li>
                  </ul>
                </div>
              </div>

              <div className="card-body">
                <div className="task-list">
                  {filteredTodos.map((todo) => (
                    <div key={todo.id} className={`task-item p-3 mb-3 border rounded ${todo.completed ? 'bg-light' : ''}`}>
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center flex-fill">
                          <div className="form-check me-3">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={todo.completed}
                              onChange={() => {}}
                            />
                          </div>
                          <div className="avatar avatar-sm bg-primary-transparent me-3">
                            <i className={`ti ${getCategoryIcon(todo.category)}`}></i>
                          </div>
                          <div className="flex-fill">
                            <h6 className={`mb-1 ${todo.completed ? 'text-decoration-line-through text-muted' : ''}`}>
                              {todo.task}
                            </h6>
                            <div className="d-flex align-items-center gap-3">
                              <small className="text-muted">
                                <i className="ti ti-book me-1"></i>{todo.subject}
                              </small>
                              <small className="text-muted">
                                <i className="ti ti-calendar me-1"></i>{todo.dueDate}
                              </small>
                              <span className={`badge ${getPriorityColor(todo.priority)}`}>
                                {todo.priority}
                              </span>
                              <span className="badge badge-soft-info">
                                {todo.category}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex gap-2">
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Edit Task</Tooltip>}
                          >
                            <button className="btn btn-sm btn-outline-primary">
                              <i className="ti ti-edit"></i>
                            </button>
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Delete Task</Tooltip>}
                          >
                            <button className="btn btn-sm btn-outline-danger">
                              <i className="ti ti-trash"></i>
                            </button>
                          </OverlayTrigger>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {filteredTodos.length === 0 && (
                  <div className="text-center py-5">
                    <div className="avatar avatar-xl bg-light-transparent mx-auto mb-3">
                      <i className="ti ti-list-check fs-2"></i>
                    </div>
                    <h5>No tasks found</h5>
                    <p className="text-muted">Add a new task to get started with your productivity!</p>
                    <button 
                      className="btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#addTodoModal"
                    >
                      <i className="ti ti-plus me-2"></i>Add Your First Task
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Todo Modal - Placeholder */}
      <div className="modal fade" id="addTodoModal">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Task</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label className="form-label">Task Title</label>
                  <input type="text" className="form-control" placeholder="Enter task title" />
                </div>
                <div className="mb-3">
                  <label className="form-label">Category</label>
                  <select className="form-select">
                    <option>Homework</option>
                    <option>Study</option>
                    <option>Assignment</option>
                    <option>Lab</option>
                    <option>Reading</option>
                  </select>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Priority</label>
                    <select className="form-select">
                      <option value="low">Low</option>
                      <option value="medium">Medium</option>
                      <option value="high">High</option>
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Due Date</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Notes</label>
                  <textarea className="form-control" rows={3} placeholder="Additional notes..."></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" className="btn btn-primary">Add Task</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToDoList;
